/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { OasDocument } from '../../openapi/models/OasDocument';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20SchemaDefinition } from '../../openapi/v2/models/Oas20SchemaDefinition';
import { RenameSchemaDefinitionCommand } from './RenameSchemaDefinitionCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends RenameSchemaDefinitionCommand
 * @class
 */
export class RenameSchemaDefinitionCommand_20 extends RenameSchemaDefinitionCommand {
    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super(oldName, newName);
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand#_nameToReference(java.lang.String)
     * @param {string} name
     * @return {string}
     */
    _nameToReference(name : string) : string {
        return "#/definitions/" + name;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand#_renameSchemaDefinition(io.apicurio.datamodels.openapi.models.OasDocument, java.lang.String, java.lang.String)
     * @param {OasDocument} document
     * @param {string} fromName
     * @param {string} toName
     * @return {boolean}
     */
    _renameSchemaDefinition(document : OasDocument, fromName : string, toName : string) : boolean {
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this.isNullOrUndefined(doc20.definitions)) {
            return false;
        }
        if(ModelUtils.isDefined(doc20.definitions.getDefinition(toName))) {
            return false;
        }
        let schemaDef : Oas20SchemaDefinition = doc20.definitions.removeDefinition(fromName);
        schemaDef.rename(toName);
        doc20.definitions.addDefinition(toName, schemaDef);
        return true;
    }
}
RenameSchemaDefinitionCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand_20";
RenameSchemaDefinitionCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




